import script from "./AdminProductDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductDetailsPage.vue?vue&type=style&index=0&id=40d3af5e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40d3af5e"]])

export default __exports__